export type ShippingAddressApiDto = {
  countryCode: string | null
  state: string | null
  city: string | null
  zipCode: string | null
  address1: string | null
  address2: string | null
}

export type ShippingAddress = {
  countryCode: string | null
  state: string | null
  city: string | null
  zipCode: string | null
  address1: string | null
  address2: string | null
}

export const toShippingAddress = (dto: ShippingAddressApiDto): ShippingAddress => ({
  countryCode: dto.countryCode,
  state: dto.state,
  city: dto.city,
  zipCode: dto.zipCode,
  address1: dto.address1,
  address2: dto.address2,
})
